/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */

import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const {
  VITE_AZURE_CLIENT_ID,
  VITE_AZURE_AUTHORITY,
  VITE_AZURE_REDIRECT_URI,
  VITE_AZURE_POST_LOGOUT_REDIRECT_URI,
} = import.meta.env;

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: VITE_AZURE_CLIENT_ID,
    authority: VITE_AZURE_AUTHORITY,
    redirectUri: VITE_AZURE_REDIRECT_URI, // Must be registered as a SPA redirectURI on your app registration
    postLogoutRedirectUri: VITE_AZURE_POST_LOGOUT_REDIRECT_URI, // Must be registered as a SPA redirectURI on your app registration
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored (localStorage or sessionStorage)
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
